import {pageInfo, editSubmit, editInit, shipInit, deliverInit, shipSubmit, deliverSubmit, scheduCancel, exportData, orderTrajectory, fileDownLoad, schedulingJobBillList, schedulingCreateValidateParam, checkDispatchDeliverNeedConfirm} from './../api';
import {addData} from "../../../mdm/truck/api";
import {addDriverData} from "../../../mdm/driver/api";
import {getCarTypeList, getDriverListByCarrierNo, getListCarrier, getTruckListByCarrierNo, listShipper} from "../../../../api";
import {
  createScheduValidateParam,
  uploadFile
} from "../../reservation/api";
const plan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    editInitObj: null,
    editObj: null,
    uploadFileObj: null,
    shipObj: null,
    deliverObj: null,
    shipSaveObj: null,
    deliverySaveObj: null,
    cancelObj: null,
    exportObj: null,
    carrierObj: null,
    orderTrajectoryObj: null,
    carTypeDataResp: null,
    addValidateParamResp: null,
    fileDownloadObj: null,
    shipCodeObj: null,
    pageOrderResp: null,
    pageOrderTotal: null,
    orderValidate: null,
    dateCheckObj: null,
  },
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item=>({
        ...item,
        btns:[{disabled: item.statusName != '等待运作' ? true : false},true, true]
      }));
    },
    EDIT_INIT(state, data) {
      state.editInitObj = data;
    },
    EDIT_SUBMIT(state, data) {
      state.editObj = data;
    },
    SAVE_TRUCK_DATA(state, data) {
      state.saveTruckResp = data;
    },
    SAVE_DRIVER_DATA(state, data) {
      state.saveDriverResp = data;
    },
    TRUCK_LIST_BY_CARRIERNO(state, data) {
      state.truckDataResp = data.obj;
    },
    DRIVER_LIST_BY_CARRIERNO(state, data) {
      state.driverDataResp = data.obj;
    },
    //上传附件
    UPLOAD_FILE(state, data) {
      state.uploadFileObj = data;
    },
    /**
     * 发运初始化
     * @param state
     * @param data
     * @constructor
     */
    SHIP_INIT(state, data) {
      state.shipObj = data;
    },
    /**
     * 送达初始化
     * @param state
     * @param data
     * @constructor
     */
    DELIVER_INIT(state, data) {
      state.deliverObj = data;
    },
    /**
     * 发运提交
     * @param state
     * @param data
     * @constructor
     */
    SHIP_SUBMIT(state, data) {
      state.shipSaveObj = data;
    },
    /**
     * 送达提交
     * @param state
     * @param data
     * @constructor
     */
    DELIVER_SUBMIT(state, data) {
      state.deliverySaveObj = data;
    },

    /**
     * 取消
     * @param state
     * @param data
     * @constructor
     */
    SCHEDU_CANCEL(state, data) {
      state.cancelObj = data;
    },
    /**
     * 导出
     * @param state
     * @param data
     * @constructor
     */
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    //承运商下拉框数据
    GET_LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    ORDER_TRAJECTORY(state,data) {
      state.orderTrajectoryObj = data.obj || {};
    },
    CAR_TYPE_LIST(state, data) {
      state.carTypeDataResp = data.obj;
    },
    ADD_VALIDATE_PARAM(state, data) {
      state.addValidateParamResp = data;
    },
    //文件下载
    FILE_DOWNLOAD(state, data){
      state.fileDownloadObj = data;
    },
    //货主
    LIST_SHIPPER(state, data) {
      state.shipCodeObj = data.obj;
    },
    /**
     * 订单查询-分页
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULING_JOB_BILL_LIST(state, data) {
      state.pageOrderTotal = data.total;
      state.pageOrderResp = (data.obj || [])
    },
    /**
     * 增加订单校验
     * @param state
     * @param data
     * @constructor
     */
    SCHEDULING_CREATE_VALIDATE_PARAM(state, data) {
      state.orderValidate = data;
    },

    /**
     * 发运/送达日期校验
     */
    CHECK_DISPATCH_DELIVER_NEED_CONFIRM(state, data) {
      state.dateCheckObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

    /**
     * 编辑初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async editInit({ commit }, obj) {
      let resp = await editInit(obj);
      commit('EDIT_INIT', resp);
    },

    /**
     * 编辑提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    },
    /**
     * 保存车辆
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveTruckData({ commit }, obj) {
      let resp = await addData(obj);
      commit('SAVE_TRUCK_DATA', resp);
    },
    /**
     * 保存司机
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveDriverData({ commit }, obj) {
      let resp = await addDriverData(obj);
      commit('SAVE_DRIVER_DATA', resp);
    },

    /**
     * 获取车辆信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getTruckListByCarrierNo({ commit }, obj) {
      let resp = await getTruckListByCarrierNo(obj);
      commit('TRUCK_LIST_BY_CARRIERNO', resp);
    },
    /**
     * 获取司机信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getDriverListByCarrierNo({ commit }, obj) {
      let resp = await getDriverListByCarrierNo(obj);
      commit('DRIVER_LIST_BY_CARRIERNO', resp);
    },

    /**
     * 上传附件
     */
    async uploadFile({commit}, obj) {
      let resp = await uploadFile(obj);
      commit('UPLOAD_FILE', resp);
    },

    /**
     * 发运初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async shipInit({commit}, obj) {
      let resp = await shipInit(obj);
      commit('SHIP_INIT', resp);
    },
    /**
     * 送达初始化
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async deliverInit({commit}, obj) {
      let resp = await deliverInit(obj);
      commit('DELIVER_INIT', resp);
    },

    /**
     * 发运提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async shipSubmit({commit}, obj) {
      let resp = await shipSubmit(obj);
      commit('SHIP_SUBMIT', resp);
    },
    /**
     * 送达提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async deliverSubmit({commit}, obj) {
      let resp = await deliverSubmit(obj);
      commit('DELIVER_SUBMIT', resp);
    },
    /**
     * 取消
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async scheduCancel({commit}, obj) {
      let resp = await scheduCancel(obj);
      commit('SCHEDU_CANCEL', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    /**
     * 获取承运商下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListCarrier({commit}, obj) {
      let resp = await getListCarrier(obj);
      commit('GET_LIST_CARRIER', resp);
    },
    //轨迹
    async orderTrajectory({commit}, obj){
      let resp = await orderTrajectory(obj);
      commit('ORDER_TRAJECTORY', resp);
    },
    /**
     * 获取车辆类型信息
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getCarTypeList({ commit }, obj) {
      let resp = await getCarTypeList(obj);
      commit('CAR_TYPE_LIST', resp);
    },
    /**
     * 预约排车的新增前置校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async createScheduValidateParam({ commit }, obj) {
      let resp = await createScheduValidateParam(obj);
      commit('ADD_VALIDATE_PARAM', resp);
    },
    //文件下载
    async fileDownLoad({commit}, obj) {
      let result = await fileDownLoad(obj);
      commit('FILE_DOWNLOAD', result);
    },
    //货主
    async getListShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //订单查询数据
    async schedulingJobBillList({commit}, obj) {
      let resp = await schedulingJobBillList(obj);
      commit('SCHEDULING_JOB_BILL_LIST', resp);
    },
    //增加订单校验
    async schedulingCreateValidateParam({commit}, obj) {
      let resp = await schedulingCreateValidateParam(obj);
      commit('SCHEDULING_CREATE_VALIDATE_PARAM', resp);
    },

    /**
     * 发运/送达日期校验
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async checkDispatchDeliverNeedConfirm({commit}, obj) {
      let resp = await checkDispatchDeliverNeedConfirm(obj);
      commit('CHECK_DISPATCH_DELIVER_NEED_CONFIRM', resp);
    },
  }
}
export default plan



// WEBPACK FOOTER //
// ./src/page/transport/plan/store/plan.store.js